// Quick Add al carrello + alert carino
(function () {
  // Delegation per sicurezza
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.quick-add');
    if (!btn) return;

    // Se il prodotto ha opzioni, mandiamo alla pagina prodotto
    if (btn.dataset.hasOptions === 'true') {
      window.location.href = btn.closest('.product-card').querySelector('.stretched-link').href;
      return;
    }

    const variantId = btn.dataset.variantId;
    const productTitle = btn.dataset.productTitle || 'Prodotto';

    if (!variantId) return;

    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (!res.ok) throw new Error('Errore aggiunta al carrello');

      await res.json();

      Swal.fire({
        icon: 'success',
        title: 'Aggiunto al carrello!',
        text: productTitle,
        confirmButtonText: 'OK'
      });
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Ops…',
        text: 'Non è stato possibile aggiungere il prodotto al carrello.',
        confirmButtonText: 'OK'
      });
      console.error(err);
    } finally {
      btn.disabled = false;
    }
  });
})();
